













































import { Component, Vue, Prop } from "vue-property-decorator";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";

@Component({
  components: {
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    EllipsisComponent
  }
})
export default class FurnitureInfoComponent extends Vue {
  @Prop()
  furnitures: any;

  getCategoryImage(iconNum: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconNum, status);
  }

  zeroPadding(num: number, length: number) {
    return ("0000000000" + num).slice(-length);
  }
}
